import "./index.css";

import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import QueryProvider from "./api/QueryProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import {
  getApiAudience,
  getAuth0ClientId,
  getAuth0Domain,
} from "./utils/auth0";
import initializeGTM from "./utils/gtm";
import { initializePostHog } from "./utils/posthog";

declare global {
  interface Window {
    __auth0ReturnTo?: string;
  }
}

// Third-party init must never block app boot — customer networks block analytics domains.
try {
  initializeGTM();
} catch (e) {
  // biome-ignore lint/suspicious/noConsole: intentional browser console output
  console.error("GTM init failed", e);
}

try {
  initializePostHog();
} catch (e) {
  // biome-ignore lint/suspicious/noConsole: intentional browser console output
  console.error("PostHog init failed", e);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Auth0Provider
        domain={getAuth0Domain()}
        clientId={getAuth0ClientId()}
        authorizationParams={{
          redirect_uri: `${window.location.origin}${window.location.search}`,
          audience: getApiAudience(),
        }}
        onRedirectCallback={(appState) => {
          if (appState?.returnTo) {
            window.__auth0ReturnTo = appState.returnTo;
          }
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname,
          );
        }}
      >
        <QueryProvider>
          <App />
        </QueryProvider>
      </Auth0Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
